import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { Component } from 'vue-property-decorator';

import { Authority, Featured, Task } from '@skinsoft/types';
import { authoritySelectors, taskSelectors } from '@skinsoft/selectors';
import { AuthorityDataStore, TaskDataStore } from '@skinsoft/entity';

import { ReactiveVue } from '@skinsoft/reactive-vue';
import { EntityFeaturedCard } from '@skinsoft/ui';
import { toFeatured$ } from '../../serializer/featured';

@Component({
    components: {
        sEntityFeaturedCard: EntityFeaturedCard,
    },
    template: require('./task-featured-card.html'),
})
export class TaskFeaturedCard extends ReactiveVue {
    public $taskDataStore: TaskDataStore;
    public serializer = (task: Task) => toFeatured$(task, this.getAppLocale());

    private overrideSerializer(task: Task): Observable<Featured> {
        return toFeatured$(task, this.getAppLocale()).pipe(
            switchMap(featured => {
                if(featured.author) {
                    const authorId: string = taskSelectors.author(task)
                    if(authorId) {
                        return AuthorityDataStore.getInstance().fetchByUser(authorId).pipe(
                            switchMap(searchResponse => {
                                let res: Authority[] = []
                                if(searchResponse.allData && searchResponse.allData.length > 0) {
                                    res = searchResponse.allData
                                } 
                                else if(searchResponse.results && searchResponse.results.length > 0) {
                                    res = searchResponse.results
                                }

                                if(res.length > 0) {
                                    let authority = res[0]
                                    const alias = authoritySelectors.firstAlias(authority)
                                    if(alias) {
                                        const value = authoritySelectors.firstAliasCompleteValue(authority, this.getAppLocale())
                                        if(value) {
                                            featured.author = value
                                        }
                                    }
                                }

                                return of(featured)
                            })
                        )
                    }
                }

                return of(featured)
            })
        )
    }
}
